import styleInject from '../../../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".tableFilterMenu .p-column-filter-buttonbar {\n\tgap: 0.5rem;\n}\n\n.c2DataTableChild .p-button.p-button-text.p-button-icon-only:hover{\n\tbackground: transparent !important;\n}\n";
styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=C2DataTable.css.js.map
